export default "__VITE_ASSET__Cy6l28l9__"